// Konva timeline color palettes. Canvas layers cannot read CSS variables, so
// we mirror Bootstrap light/dark intent with explicit tokens.

/** @typedef {'light' | 'dark'} EffectiveTheme */

/** @type {Record<EffectiveTheme, object>} */
const PALETTES = {
    dark: {
        shellBg: "#1d1d1d",
        waveformBg: "#161616",
        waveformColor: "#0fbc8c",
        minimapBg: "#0e0e0e",
        minimapWaveColor: "#bdbdbd",
        rulerBg: "#1f1f1f",
        rulerBorder: "#3a3a3a",
        rulerText: "#cfcfcf",
        rulerTickMajor: "#7a7a7a",
        rulerTickMinor: "#555",
        gridLine: "rgba(255, 255, 255, 0.05)",
        trackRowBg: "rgba(255, 255, 255, 0.02)",
        trackRowBgAlt: "rgba(255, 255, 255, 0.04)",
        regionWaveform: "#ffffff",
        regionLabel: "#ffffff",
        markerLabelBg: "rgba(0, 0, 0, 0.65)",
        markerLabelFg: "#ffffff",
        filmstripBg: "#0b0b0b",
        filmstripThumbBg: "#000000",
        filmstripFrameBorder: "#2a2a2a",
        filmstripPlaceholderText: "#888",
        filmstripTimecodeText: "#cfcfcf",
        minimapViewportFill: "rgba(255, 255, 255, 0.12)",
        minimapViewportStroke: "rgba(255, 255, 255, 0.55)",
        playhead: "#FFF700",
        handleFillIdle: "rgba(255, 255, 255, 0.35)",
        handleFillSelected: "rgba(255, 235, 59, 0.85)"
    },
    light: {
        shellBg: "#f8f9fa",
        waveformBg: "#e9ecef",
        waveformColor: "#0a9e78",
        minimapBg: "#e9ecef",
        minimapWaveColor: "#6c757d",
        rulerBg: "#dee2e6",
        rulerBorder: "#adb5bd",
        rulerText: "#212529",
        rulerTickMajor: "#6c757d",
        rulerTickMinor: "#adb5bd",
        gridLine: "rgba(0, 0, 0, 0.06)",
        trackRowBg: "rgba(0, 0, 0, 0.02)",
        trackRowBgAlt: "rgba(0, 0, 0, 0.04)",
        regionWaveform: "#0d6efd",
        regionLabel: "#212529",
        markerLabelBg: "rgba(255, 255, 255, 0.92)",
        markerLabelFg: "#212529",
        filmstripBg: "#cfd4da",
        filmstripThumbBg: "#dee2e6",
        filmstripFrameBorder: "#adb5bd",
        filmstripPlaceholderText: "#6c757d",
        filmstripTimecodeText: "#212529",
        minimapViewportFill: "rgba(0, 0, 0, 0.08)",
        minimapViewportStroke: "rgba(0, 0, 0, 0.35)",
        playhead: "#FFF700",
        handleFillIdle: "rgba(0, 0, 0, 0.25)",
        handleFillSelected: "rgba(255, 193, 7, 0.9)"
    }
};

/**
 * @param {EffectiveTheme} effectiveTheme
 * @returns {typeof PALETTES.dark}
 */
export function getTimelinePalette(effectiveTheme) {
    return PALETTES[effectiveTheme === "light" ? "light" : "dark"];
}
